import { render } from "./WAICreateView.vue?vue&type=template&id=b975efc0"
import script from "./WAICreateView.vue?vue&type=script&lang=js"
export * from "./WAICreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__